// Runtime rendering flags (URL query params).

const params = new URLSearchParams(
  typeof window !== 'undefined' ? window.location.search : ''
);

/** GPU renderer is default; use ?renderer=software for the legacy framebuffer path. */
export function isGpuRenderer(): boolean {
  const r = params.get('renderer');
  if (r === 'software') return false;
  if (r === 'gpu') return true;
  return true;
}

/** DOM HUD overlay is default with GPU; use ?hud=canvas to keep framebuffer HUD. */
export function isDomHud(): boolean {
  const h = params.get('hud');
  if (h === 'canvas') return false;
  if (h === 'dom') return true;
  return isGpuRenderer();
}

/** Optional cap on extended horizontal FOV (?maxTiles=25). */
export function maxVisibleTilesX(): number | null {
  const v = params.get('maxTiles');
  if (!v) return null;
  const n = parseInt(v, 10);
  return Number.isFinite(n) && n >= 21 ? n : null;
}
